import { isOpenAdminCancelPaymentModal } from "@/atoms/order/is-open-admin-cancel-payment-modal";
import { orderDetailState } from "@/atoms/order/order-detail-state";
import { toastState } from "@/atoms/system/toast-state";
import { ButtonColor } from "@/common/enum/button-color";
import { orderService } from "@/services/order-service2";
import { paymentService } from "@/services/payment-service";
import { Button, Modal, TextInput } from "flowbite-react";
import React, { useState } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import { TextInputLabel } from "../label/TextInputLabel";
import { Body14Regular } from "../typography/Body14Regular";
import { H4 } from "../typography/H4";
import { H5 } from "../typography/H5";

interface Props { }

export const AdminCancelPaymentModal: React.FC<Props> = ({ }) => {
  const [payload, setPayload] = useState({
    cancelingAmount: "",
    reason: "관리자 취소",
  });
  const [modal, setModal] = useRecoilState(isOpenAdminCancelPaymentModal);
  const [orderDetail, setOrderDetail] = useRecoilState(orderDetailState);
  const setToast = useSetRecoilState(toastState);

  if (!orderDetail) {
    return null;
  }

  if (!modal) {
    return null;
  }

  const active = !!payload.cancelingAmount;

  const closeModal = () => {
    setModal(false);
  };

  const handleClick = async () => {
    if (orderDetail.payment.id === 0) return;
    try {
      const response = await paymentService.cancel(orderDetail.payment.id, {
        ...payload,
        cancelingAmount: Number(payload.cancelingAmount),
      });
      if (!response.ok) {
        return;
      }
      const getByIdResponse = await orderService.getById(orderDetail.id);
      if (!getByIdResponse.ok) {
        return;
      }
      setOrderDetail(getByIdResponse.data);
      setToast({
        show: true,
        messages: [`발주 취소가 완료되었습니다.`],
      });
      closeModal();
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangeAmount = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    // 숫자만 입력받도록 필터링
    if (/^\d*$/.test(value)) {
      setPayload({ ...payload, cancelingAmount: value });
    }
  };

  return (
    <Modal size="2xl" show={true} onClose={closeModal}>
      <Modal.Header className="p-[24px] h-[76px]">
        <H4>결제 취소하기</H4>
      </Modal.Header>
      <Modal.Body>
        <div className="flex flex-col justify-center items-center">
          <div className="box-border border border-semantic-system-error-primary rounded-[8px] w-[572px] h-[134px] bg-semantic-system-error-10 flex justify-center flex-col py-[16px] px-[12px] gap-[12px]">
            <H5 className="text-semantic-system-error-text">주의하세요!</H5>
            <div className="flex flex-col">
              <Body14Regular className="text-semantic-system-error-text">
                ERP 등록 이후 발주건 취소는 ERP에서 먼저 진행해야합니다.
              </Body14Regular>
              <Body14Regular className="text-semantic-system-error-text">
                마스터에서 취소 처리는 단순 확인용입니다. 마스터에서 발주 취소를
              </Body14Regular>
              <Body14Regular className="text-semantic-system-error-text">
                진행해도 ERP에 자동 취소 접수가 되지 않습니다.
              </Body14Regular>
            </div>
          </div>
          <div className="flex flex-col gap-[20px] mt-[20px]">
            <div className="flex flex-col">
              <TextInputLabel required>환불받을 금액</TextInputLabel>
              <TextInput
                required
                className="w-[572px]"
                placeholder="금액을 입력해주세요"
                name="cancelingAmount"
                type="number"
                value={payload.cancelingAmount}
                onChange={handleChangeAmount}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="w-full"
          disabled={!active}
          color={active ? ButtonColor.PRIMARY : ""}
          onClick={handleClick}
        >
          발주 취소하기
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
